export default "__VITE_ASSET__F$UPRnQe__"